// ============================================================================
// GESTIMMONY — Portail Locataire : première activation (magic link)
// ============================================================================
import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function PortalActivatePage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Les mots de passe ne correspondent pas"); return; }
    setBusy(true);
    try {
      await api.post("/portal/set-password", { token, password });
      toast.success("Compte activé — bienvenue !");
      navigate("/portail");
    } catch (e) {
      toast.error(e.response?.data?.detail || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="portal-activate-page">
      <Card className="w-full max-w-md p-8">
        <div className="flex items-center gap-3 mb-4">
          <div className="h-10 w-10 rounded-lg bg-gradient-to-br from-teal-500 to-emerald-600 flex items-center justify-center">
            <KeyRound className="h-5 w-5 text-white" />
          </div>
          <div>
            <h1 className="font-heading font-bold text-xl">Activation du compte</h1>
            <p className="text-sm text-slate-500">Choisissez votre mot de passe pour accéder au portail</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>Nouveau mot de passe (6 caractères minimum)</Label>
            <Input data-testid="portal-activate-pwd" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" />
          </div>
          <div>
            <Label>Confirmer</Label>
            <Input data-testid="portal-activate-confirm" type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1" />
          </div>
          <Button data-testid="portal-activate-submit" type="submit" disabled={busy} className="w-full bg-[hsl(var(--primary))]">
            {busy ? "Activation…" : "Activer et se connecter"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
